import React, { useEffect } from 'react';
import { track } from '@amplitude/analytics-browser';
import { Alert } from '@nimbus-ds/components';
import { useBalance, useIdentityValidation } from 'commons/hooks';
import { useTranslationWithPrefix } from 'commons/utils';
import { PendingTrialPeriodAlertPage } from '../PendingTrialPeriodAlert';
import { getDeniedTranslationKeys } from './getDeniedTranslationsKeys';

interface InterfaceDeniedAlert {
  page: PendingTrialPeriodAlertPage;
}

const DeniedAlert = ({ page }: InterfaceDeniedAlert): JSX.Element | null => {
  const { t } = useTranslationWithPrefix('commons.deniedAlert');
  const identityValidation = useIdentityValidation();
  const {
    waitingFunds,
    availableToWithdraw,
    isLoading: balanceLoading,
  } = useBalance();

  const hasBalance = waitingFunds.value > 0 || availableToWithdraw.value > 0;

  const statusDetail = identityValidation.data?.statusDetail;
  const { descriptionKey, titleKey } = getDeniedTranslationKeys(
    statusDetail,
    hasBalance,
  );

  useEffect(() => {
    track('pago-nube-documentacion-rechazado-view', {
      page,
    });
  }, [page]);

  if (balanceLoading) return null;

  return (
    <Alert
      data-testid="denied-alert"
      title={t(titleKey)}
      show
      appearance="danger"
    >
      {t(descriptionKey)}
    </Alert>
  );
};

export default DeniedAlert;
